import { PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { Flex } from '@mantine/core';
import { useClickOutside } from '@mantine/hooks';
import { useLocation } from 'react-router-dom';

// Assets
import classes from './Topbar.module.css';
import ChevronDown from '@/assets/icons/content/chevron-down.svg';

interface DropdownProps {
  icon: ReactNode;
  hideArrow?: boolean;
  size?: number;
  /** Moon design system account / notifications panel (no caret, shadow, border). */
  appearance?: 'default' | 'moonPanel';
  triggerClassName?: string;
}

const DropdownMenu = ({
  children,
  icon: Icon,
  hideArrow = false,
  size = 180,
  appearance = 'default',
  triggerClassName,
}: PropsWithChildren<DropdownProps>) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded((state) => !state);
  };

  const collapse = () => setExpanded(false);

  const clickRef = useClickOutside(collapse);
  const location = useLocation();

  useEffect(() => {
    setExpanded(false);
  }, [location.pathname, location.search]);

  const triggerClasses = [classes.iconWrapper, triggerClassName, expanded && classes.expanded]
    .filter(Boolean)
    .join(' ');
  const menuClasses = [
    classes.dropdownMenu,
    appearance === 'moonPanel' && classes.dropdownMenuMoon,
    expanded && classes.expanded,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes.dropdown} ref={clickRef}>
      <Flex
        component="button"
        type="button"
        className={triggerClasses}
        onClick={toggleExpanded}
        gap={0}
      >
        {Icon}
        {!hideArrow && <ChevronDown />}
      </Flex>

      <ul
        className={menuClasses}
        style={{
          ['--dropdown-menu-size' as string]: `${size}px`,
        }}
      >
        {children}
      </ul>
    </div>
  );
};

export default DropdownMenu;
